import React from 'react';
import classnames from 'classnames';

import styles from './fundHoldingsStyles';

import FundHoldingCard from './FundHoldingCard/fundHoldingCard';
import DocumentList from 'buyside/components/presentation/DocumentList/documentList';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';
import { formatDate } from 'buyside/util/dateHelper';

const FundHoldings = ({ fundProfile, shrink }) => {
  const { holdings, holdingsUpdatedDate, holdingsDocuments } = fundProfile;
  return (
    <div>
      <div className={classnames(styles.fundHoldingsMainArea, { [styles.narrow]: shrink })}>
        {holdings.map((holding, idx) => (
          <div key={idx} className={styles.fundHoldingContainer}>
            <FundHoldingCard holding={holding} />
          </div>
        ))}
      </div>
      <div className={styles.fundHoldingsFooter}>
        Holdings current as of {formatDate(holdingsUpdatedDate)}.
      </div>
      <div className={styles.fundHoldingsFooter}>
        <strong>Note:</strong> it should not be assumed that recommendations made in the future will
        be profitable, or will equal the performance of the securities in this list.
      </div>
      {!!holdingsDocuments.length && (
        <DocumentList
          title="Supporting Documents"
          documents={holdingsDocuments}
          urlFn={employerProfileDocumentUrl}
        />
      )}
    </div>
  );
};

export default FundHoldings;
